import { tss } from 'tss-react/mui';

export const useStyles = tss
  .withParams<{ isTranscriptTab: boolean; headerHeight: number }>()
  .create(({ theme, isTranscriptTab, headerHeight }) => ({
    loadingContent: {
      paddingTop: theme.spacing(1),
      height: `calc(100vh - ${headerHeight}px - 6px)`,
      minHeight: 0,
      overflow: 'hidden',
      boxSizing: 'border-box',
    },
    loadingPaper: {
      padding: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
      },
    },
    loadingGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
      [theme.breakpoints.up('lg')]: {
        gridTemplateColumns: 'repeat(4, 1fr)',
      },
    },
    pageContent: {
      paddingTop: theme.spacing(3),
      height: isTranscriptTab
        ? `calc(100vh - ${headerHeight}px - 6px)`
        : '100%' /* -6px is kind of magic for windows browsers to prevent vertical scroll */,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    recordingTabs: {
      position: 'sticky',
      top: 0,
      zIndex: theme.zIndex.appBar - 1,
      backgroundColor: theme.palette.background.default,
      paddingTop: theme.spacing(1),
    },
    tabControls: {
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(1),
    },
    tabs: {
      flex: 1,
      minWidth: 0,
      backgroundColor: theme.palette.background.default,
      '& .MuiTab-root': {
        minHeight: 40,
        minWidth: 0,
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        fontSize: 14,
      },
      '& .MuiTab-iconWrapper': {
        marginBottom: 0,
        marginRight: theme.spacing(0.5),
      },
    },
    tabIcon: {
      fontSize: 16,
    },
    downloadButton: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(2),
    },
    tabPanels: {
      flex: 1,
      minHeight: 0,
      // Override MUI Stack spacing margin applied to direct children.
      marginTop: '0 !important',
    },
    tabPanel: {
      height: '100%',
      minHeight: 0,
      overflow: 'hidden',
    },
    hiddenTabPanel: {
      display: 'none',
    },
  }));
